import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const CreditCard = ({
  width = 24,
  height = 24,
  className,
  color = "primary",
  decorative = false,
  ariaLabel = "Credit card",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <rect x="2" y="4" width="20" height="16" rx="2" ry="2" stroke="#06C" />
      <line x1="2" y1="9" x2="22" y2="9" stroke="#06C" />
      <line x1="6" y1="14" x2="10" y2="14" stroke="#06C" />
    </svg>
  );
};


